"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShoplandingPaymentGroups = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const andes_react_1 = require("@yonderland/andes-react");
const LocalStorageUtil_1 = tslib_1.__importDefault(require("../../../util/LocalStorageUtil"));
const StorageKeysConstants_1 = require("../../../constants/StorageKeysConstants");
const PaymentGroupContent_1 = require("./payment-groups/PaymentGroupContent");
const CheckoutPaymentContext_1 = require("../../../context/CheckoutPaymentContext");
const common_queries_1 = require("@as-react/common-queries");
const react_query_1 = require("@tanstack/react-query");
const common_components_1 = require("@as-react/common-components");
const URLParamUtil_1 = require("../../../util/URLParamUtil");
const common_types_1 = require("@as-react/common-types");
const PAY_ON_TILL = 'PAY_ON_TILL';
const ShoplandingPaymentGroups = () => {
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.buy);
    const [{ info }] = (0, CheckoutPaymentContext_1.usePaymentState)();
    const { defaultRequestParams, isInAuthorMode, root, servicesEndpoint } = (0, common_components_1.useAemConfig)();
    const { postShoplandingPayment } = (0, common_queries_1.checkoutMutations)({ servicesEndpoint, defaultRequestParams });
    const { mutateAsync: postShoplandingPaymentMutation } = (0, react_query_1.useMutation)(postShoplandingPayment);
    const onSubmit = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const storeNumber = LocalStorageUtil_1.default.getJsonItem(StorageKeysConstants_1.SHOP_NUMBER_STORAGE_KEY);
        yield postShoplandingPaymentMutation(storeNumber);
        const search = {
            status: 'accept',
            orderID: info.orderReference,
        };
        const location = (0, URLParamUtil_1.generatePathUrl)(root, `buy/${common_types_1.RoutePathname.CONFIRMATION}.html`, isInAuthorMode, search);
        window.location.href = `${location.pathname}?${location.search}`;
    });
    return ((0, jsx_runtime_1.jsxs)(andes_react_1.SelectionCard, { id: `shoplanding_${PAY_ON_TILL}`, state: "active", hasGapY: false, testId: `payment_option_${PAY_ON_TILL.toLowerCase()}`, children: [(0, jsx_runtime_1.jsx)(andes_react_1.SelectionCard.Cell, { section: "media", cellProps: { align: 'stretch' }, children: (0, jsx_runtime_1.jsx)(andes_react_1.Box, { paddingBlockStart: "0.5", children: (0, jsx_runtime_1.jsx)(andes_react_1.RadioButton, { id: PAY_ON_TILL, name: "checkout-delivery-options", value: PAY_ON_TILL, checked: true }) }) }), (0, jsx_runtime_1.jsx)(andes_react_1.SelectionCard.Cell, { section: "header", cellProps: { align: 'center' }, children: (0, jsx_runtime_1.jsx)(andes_react_1.TextAlpha, { color: "neutral", children: t('buy.confirmation.shop.pay.at.checkout', { orderId: '' }) }) }), (0, jsx_runtime_1.jsx)(andes_react_1.SelectionCard.Cell, { section: "content", children: (0, jsx_runtime_1.jsx)(PaymentGroupContent_1.PaymentGroupContent, { submitButtonText: t('buy.payment.confirm'), selected: true, group: {
                        name: PAY_ON_TILL,
                        ogoneAliases: null,
                        paymentOptions: [],
                        sortOrder: 0,
                        supportsTokenization: false,
                        weight: 0,
                        amountPayableWithOption: null,
                    }, onSubmit: onSubmit }) })] }));
};
exports.ShoplandingPaymentGroups = ShoplandingPaymentGroups;
